var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCastles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M496,0h-96c-8.84,0-16,7.16-16,16v112h-64V16c0-8.84-7.16-16-16-16h-96c-8.84,0-16,7.16-16,16v112h-64V16c0-8.84-7.16-16-16-16H16C7.2,0,0,7.2,0,16V176c0,20.9,13.4,38.7,32,45.3v242.7c0,26.51,21.49,48,48,48h112v-127.03c0-35.13,27.91-64.44,63.03-64.96,35.74-.53,64.97,28.37,64.97,63.99v128h112c26.51,0,48-21.49,48-48V221.3c18.6-6.6,32-24.4,32-45.3V16c0-8.8-7.2-16-16-16Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCastles);
export default __webpack_public_path__ + "static/media/castles.3ce3c1b97aec3ff0cacfa453e973ee38.svg";
export { ForwardRef as ReactComponent };